import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./App.css";

// Initialize Wix SDK if available
// @ts-ignore - Wix SDK global
if (typeof window !== "undefined" && window.Wix) {
  // @ts-ignore
  window.Wix?.Widgets?.reactDOMRender?.(React);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
